<template>
    <div class="login-container">
        <div class="login-header" style="height:60px;text-align:center;line-height:60px;">
            Login
        </div>
        
        <div class="login-content">
            <div class="logo-container">
                <div class="logo-box">
                    <img src="../../assets/images/ledis-logo.png" alt="Jewelry" class="logo-image">
                </div>
            </div>
            
            <div class="login-form">
                <div><span>{{ $t('common.jewelrySales') }}</span></div><br>
                <div class="input-item username">
                    <i class="user-icon"></i>
                    <input type="text" v-model="loginForm.account" :placeholder="$t('common.pleaseInput')" maxlength="50" @keyup.enter="handleSubmit">
                </div>
                
                <div class="input-item password">
                    <i class="password-icon"></i>
                    <input type="password" v-model="loginForm.password" :placeholder="$t('common.pleaseInput')" maxlength="20" @keyup.enter="handleSubmit">
                </div>
                <!--
                <div class="remember-row">
                    <label class="checkbox-container">
                        <input type="checkbox" v-model="checked">
                        <span class="checkmark"></span>
                        记住密码
                    </label>
                </div>
                
                <div class="agreement-row">
                    <label class="checkbox-container">
                        <input type="checkbox" v-model="agreedToTerms">
                        <span class="checkmark"></span>
                    </label>
                    <span class="agreement-text">珠宝钻石服务平台·<a href="javascript:void(0)">用户服务协议 >></a></span>
                </div>
                -->
                <button class="login-btn" @click="handleSubmit">{{ $t('button.login') }}</button>
                <!--
                <div class="quick-register">
                    <a href="javascript:void(0)" @click="goToRegister">快速注册 <i class="register-icon"></i></a>
                </div>
                -->
            </div>
        </div>
        
        <div class="footer">
            <!--
            <span>CopyRight (C) 2022-2025，乐蒂斯版权所有</span><br>
            <span>公司地址：万山珠宝园A座1109-2</span><br>
            -->
            <span><a href="https://beian.miit.gov.cn">网站备案号：粤ICP备2021134073号</a></span>
        </div>
    </div>
</template>

<script>
    import util from '../../common/js/util';
    import config from '../../common/js/config';
    import cookieOperation from '../../common/js/cookieOperation';
    import sessionTimeout from '../../common/js/sessionTimeout';
    const Base64 = require('js-base64').Base64;
    
    export default {
        data() {
            return {
                logining: false,
                checked: false,
                agreedToTerms: false,
                loginForm: {
                    account: '',
                    password: ''
                }
            }
        },
        methods: {
            handleSubmit() {
                let _this = this;
                
                if (!this.loginForm.account || !this.loginForm.password) {
                    this.$message.error('请输入用户名和密码');
                    return;
                }
                /*
                if (!this.agreedToTerms) {
                    this.$message.error('请阅读并同意用户服务协议');
                    return;
                }
                */
                cookieOperation.cookie.delete('access_token');
                cookieOperation.cookie.delete('userName');
                cookieOperation.cookie.delete('userType');
                cookieOperation.cookie.delete('userDept');
                sessionStorage.clear();

                _this.logining = true;
                util.publicLogin('/user/loginD', {
                    username: _this.loginForm.account,
                    password: _this.loginForm.password
                }, function (loginRes) {
                    _this.logining = false;
                    if (loginRes.flag) {
                        cookieOperation.cookie.set('access_token', loginRes.token, 10); // token
                        cookieOperation.cookie.set('userName', loginRes.userName, 10); // 账号
                        cookieOperation.cookie.set('userType', loginRes.userType, 10); // 1为领导，0为经理
                        cookieOperation.cookie.set('userDept', loginRes.userDept, 10); // 企业名称、部门
                        
                        sessionStorage.setItem('access_token', loginRes.token);
                        sessionStorage.setItem('userName', loginRes.userName);
                        sessionStorage.setItem('userType', loginRes.userType);
                        sessionStorage.setItem('userDept', loginRes.userDept);
                        let token_time = sessionStorage.getItem('access_token') + '_' + new Date().getTime();
                        sessionStorage.setItem('token_time', token_time);

                        // 初始化会话超时监控
                        sessionTimeout.reset();

                        // 根据设备类型跳转到不同页面
                        if (_this.isMobile()) {
                            _this.$router.push({path: '/index'});
                        } else {
                            _this.$router.push({path: '/homepc'});
                        }
                    } else {
                        _this.$message.error(loginRes.msg);
                    }
                }, config.service_ip);
            },
            goToRegister() {
                this.$router.push('/register');
            },
            isMobile() {
                // 优先使用 uaData 判断（兼容支持该属性的 Chromium 内核浏览器）
                if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
                    return navigator.userAgentData.mobile;
                }

                const ua = navigator.userAgent || '';
                const platform = navigator.platform || '';

                // 检查 UA 中是否明确包含桌面端标识（Windows、Mac OS X、Linux 等）
                const isDesktopUA = /(Windows NT|Macintosh|Linux|X11)/i.test(ua);
                
                // 如果 UA 明确标识为桌面端，且不包含移动端关键字，则判断为桌面端
                if (isDesktopUA && !/(phone|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|iPad|iPhone|iPod)/i.test(ua)) {
                    return false;
                }

                // 常见移动端 UA 关键字（包含大部分手机与平板）
                const isMobileUA = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(ua);
                
                // iOS 13+ 的 iPad 会伪装成桌面端，需要额外判断
                const isModernIPad = /MacIntel/.test(platform) && navigator.maxTouchPoints > 1;

                return isMobileUA || isModernIPad;
            }
        },
        mounted() {
            // 检测是否是移动端，可以添加特定的类名来适配不同设备
            console.log(this.isMobile());
            if (this.isMobile()) {
                document.body.classList.add('mobile-device');
            }
        }
    };
</script>

<style scoped>
    /* 通用样式 */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    
    .login-container {
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }
    
    /* 顶部标题栏 */
    .login-header {
        height: 50px;
        line-height: 50px;
        text-align: center;
        background-color: #4285f4;
        color: white;
        font-size: 18px;
    }
    
    /* 内容区域 */
    .login-content {
        display: flex;
        flex: 1;
    }
    
    /* Logo区域 */
    .logo-container {
        flex: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
    }
    
    .logo-box {
        text-align: center;
    }
    
    .logo-image {
        width: 420px;
        height: auto;
        margin-bottom: 15px;
    }
    
    .logo-text {
        font-size: 24px;
        color: #666;
        margin-bottom: 5px;
    }
    
    .logo-text-en {
        font-size: 16px;
        color: #999;
        letter-spacing: 2px;
    }
    
    /* 表单区域 */
    .login-form {
        flex: 2;
        padding: 0 0 0 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: white;
    }
    
    /* 输入框样式 */
    .input-item {
        position: relative;
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        width: 300px;
    }
    
    .input-item input {
        flex: 1;
        height: 40px;
        border: none;
        background: transparent;
        font-size: 14px;
        padding-left: 10px;
        outline: none;
        color: #333;
    }
    
    .input-item input::placeholder {
        color: #999;
    }
    
    .user-icon, .password-icon {
        width: 50px;
        height: 50px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        align-self: center;
        margin-bottom: 0;
    } 
    .user-icon {
        background-image: url('../../assets/images/userIcon.png');
    }
    
    .password-icon {
        background-image: url('../../assets/images/passwordIcon.png');
    }
    
    /* 复选框样式 */
    .checkbox-container {
        display: inline-flex;
        align-items: center;
        position: relative;
        padding-left: 25px;
        cursor: pointer;
        font-size: 14px;
        color: #666;
    }
    
    .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    
    .checkmark {
        position: absolute;
        left: 0;
        height: 18px;
        width: 18px;
        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 2px;
    }
    
    .checkbox-container input:checked ~ .checkmark {
        background-color: #4285f4;
        border-color: #4285f4;
    }
    
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }
    
    .checkbox-container input:checked ~ .checkmark:after {
        display: block;
    }
    
    .checkbox-container .checkmark:after {
        left: 6px;
        top: 2px;
        width: 4px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
    
    .remember-row {
        margin-bottom: 15px;
    }
    
    /* 协议行样式 */
    .agreement-row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    
    .agreement-text {
        font-size: 12px;
        color: #666;
    }
    
    .agreement-text a {
        color: #4285f4;
        text-decoration: none;
    }
    
    /* 登录按钮 */
    .login-btn {
        width: 300px;
        height: 40px;
        background-color: #4285f4;
        color: white;
        border: none;
        border-radius: 2px;
        font-size: 16px;
        margin: 0 0 20px 0;
        cursor: pointer;
    }
    
    /* 快速注册 */
    .quick-register {
        text-align: center;
        margin-bottom: 20px;
    }
    
    .quick-register a {
        color: #4285f4;
        text-decoration: none;
        font-size: 14px;
    }
    
    .register-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%234285f4"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        vertical-align: middle;
    }
    
    /* 底部版权 */
    .footer {
        margin-top: auto;
        text-align: center;
        padding: 10px 0;
        font-size: 12px;
        color: #999;
    }
    
    .footer a {
        color: #999;
        text-decoration: none;
    }
    
    /* 移动端适配 */
    @media screen and (max-width: 768px) {
        .login-container {
            justify-content: flex-start;
        }
        
        .login-content {
            flex-direction: column;
            min-height: 80vh;
        }
        
        .logo-container {
            height: 200px;
            padding-top: 30px;
        }
        
        .logo-image {
            width: 280px;
            margin-bottom: 10px;
        }
        
        .login-form {
            width: 100%;
            padding: 20px;
            padding-bottom: 60px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
        }
        
        .input-item {
            width: 90%;
            margin-bottom: 20px;
        }
        
        .login-btn {
            width: 90%;
            height: 45px;
            margin: 0 0 40px 0;
        }
        
        .footer {
            padding-bottom: 20px;
        }
    }
</style> 


// WEBPACK FOOTER //
// src/components/login/login.vue